import React, { Component } from "react";
import history from "../history";
import "../Center.css";
const Web3 = require("web3");
let web3;

class TestnetEth extends Component {
  state = {
    userAddress: "",
    blackList: false
  };

  async componentDidMount() {
    web3 = new Web3(window.web3.currentProvider);
    const accounts = await web3.eth.getAccounts();
    const userAddress = accounts[0];
    this.setState({
      userAddress
    });
    console.log("User Address", this.state.userAddress);
  }

  nextScreen = async () => {
    window.open("https://faucet.metamask.io/", "_blank"); //to open new page
    history.push(`${process.env.PUBLIC_URL}/CustomToken`);
  };

  render() {
    return (
      <div className="Start">
        <div className="lander">
          <form>
            <h1>Get Testnet ETH</h1>
            <p>
              First, you'll need Gas to try the demo.
              <br />
              <ol>
                <li>Click the button below to open the faucet in a new tab</li>
                <li>Click on <b>"request 1 ether from faucet"</b></li>
                <li>Return here and continue the setup</li>
              </ol>
              Click below to get some Gas.
            </p>
            <div className="row bottom">
              <div className="col-md-4">
                <button
                  type="button"
                  className="primary-btn btn-block"
                  onClick={this.nextScreen}
                >
                  Get Testnet Gas
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default TestnetEth;
